var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotation = function SvgNotation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    clipPath: "url(#notation_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.18 22.995a1 1 0 1 0 2 0zm0-21.046v21.046h2V1.949z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.008 19.819a1 1 0 0 0 0 2zm20.96 0H1.009v2h20.96zM3.014.18a.225.225 0 0 1 .331 0l2.538 2.756a.225.225 0 0 1-.166.378H.646a.225.225 0 0 1-.166-.378z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.82 20.652a.225.225 0 0 1 0 .331l-2.756 2.538a.225.225 0 0 1-.378-.166v-5.071c0-.196.233-.298.378-.166zM5.805 7.25a.75.75 0 0 0 0-1.5zM4 7.25h1.805v-1.5H4zM5.805 11.75a.75.75 0 0 0 0-1.5zM4 11.75h1.805v-1.5H4zM5.805 16.25a.75.75 0 0 0 0-1.5zM4 16.25h1.805v-1.5H4zM9.25 18.195a.75.75 0 0 0-1.5 0zm0 1.805v-1.805h-1.5V20zM13.75 18.195a.75.75 0 0 0-1.5 0zm0 1.805v-1.805h-1.5V20zM18.25 18.195a.75.75 0 0 0-1.5 0zm0 1.805v-1.805h-1.5V20zM8.267 4.693l.198.042a1 1 0 0 0 .162.018.28.28 0 0 0 .186-.06.5.5 0 0 0 .15-.204 2.6 2.6 0 0 0 .15-.408L7.871.937h.834l.846 2.322.744-2.322h.768l-1.32 3.768q-.072.21-.222.378a.96.96 0 0 1-.366.27 1.12 1.12 0 0 1-.678.084 1 1 0 0 1-.21-.048zM19.663 13.494l.66.984.048.108.06-.108.654-.984h.846L20.84 15.06l1.11 1.578h-.846l-.678-.978-.054-.102-.048.102-.672.978h-.846l1.11-1.56-1.092-1.584z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "notation_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgNotation;